import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <section className="not-found">
      <div className="projects-hero-orb projects-hero-orb--1" aria-hidden="true" />
      <div className="projects-hero-orb projects-hero-orb--2" aria-hidden="true" />
      <div className="projects-hero-orb projects-hero-orb--3" aria-hidden="true" />
      <div className="projects-hero-orb projects-hero-orb--4" aria-hidden="true" />

      <div className="projects-hero-particles" aria-hidden="true">
        {Array.from({ length: 12 }).map((_, i) => (
          <span key={i} className="projects-hero-particle" />
        ))}
      </div>
      <div className="not-found-inner">
        <p className="not-found-kicker">404</p>
        <h1 className="projects-hero-title">
          <span className="title-emerald">Page</span>{' '}
          <span className="title-gold">Not Found</span>
        </h1>
        <p className="not-found-description">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="not-found-link">
            Back to Home
          </Link>
          <Link to="/projects" className="not-found-link alt">
            View Projects
          </Link>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
